// extracted by mini-css-extract-plugin
export default {"header":"style--header--8e1bd3"};